import React from 'react';

import {styles} from './styles';
import Text from '../Text';
import PropTypes from 'prop-types';

const DownloadLink = ({href, filename, children}) => {
  return (
    <a href={href} style={styles.anchor} target="_blank" rel="noreferrer">
      <Text style={styles.link}>{children}</Text>
    </a>
  );
};
DownloadLink.propTypes = {
  href: PropTypes.any,
  filename: PropTypes.any,
  children: PropTypes.any,
};


export default DownloadLink;
